import React from 'react'
import Freemium from './Freemium'

const REDACTED = 'redacted'

const withFreemium = ({ prop, buttontext, layout = 'inline', href }) => Component => {
  const WithFreemium = props => (
    props[prop] === REDACTED ? <Freemium buttontext={buttontext} layout={layout} href={href} /> : <Component {...props} />
  )

  WithFreemium.displayName = Component.displayName
    ? `WithFreemium(${Component.displayName})`
    : 'WithFreemium'

  return WithFreemium
}

export default withFreemium
